import React, { useState } from "react";
import { Nav, Dropdown } from "react-bootstrap";
import Notifications from "./Notifications";
import UserActions from "./UserActions";
import ThemeToggle from "../ThemeToggle";
import i18n from "i18next";
import ReactCountryFlag from "react-country-flag";
import { Globe } from "lucide-react";
import "../MainNavbar.css";

const SidebarNav = () => {
  const [local, setLocal] = useState(localStorage.getItem("local") || "en");

  const changeLanguageHandler = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("local", lang);
    setLocal(lang);
  };

  // Map of languages
  const languages = {
    ar: { label: "AR", flag: "TN" },
    fr: { label: "FR", flag: "FR" },
    en: { label: "EN", flag: "GB" },
    it: { label: "IT", flag: "IT" },
    wf: { label: "WF", flag: "sn" }, // custom globe
  };

  return (
    <Nav className="smartfarm-header-nav border-left d-flex align-items-center justify-content-between p-2 h-100" navbar>
      {/* Language Dropdown on the left */}
      <Dropdown>
        <Dropdown.Toggle
          variant="light"
          size="sm"
          className="d-flex align-items-center shadow-sm border-0 rounded px-2"
          id="dropdown-lang"
        >
          {languages[local].flag ? (
            <ReactCountryFlag
              countryCode={languages[local].flag}
              svg
              className="lang-flag-icon"
            />
          ) : (
            <Globe className="lang-flag-icon" aria-hidden="true" />
          )}
          {languages[local].label}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {Object.keys(languages).map((lang) => (
            <Dropdown.Item key={lang} onClick={() => changeLanguageHandler(lang)}>
              {languages[lang].flag ? (
                <ReactCountryFlag
                  countryCode={languages[lang].flag}
                  svg
                  style={{ width: "1.2em", height: "1.2em", marginRight: "6px" }}
                />
              ) : (
                <span style={{ marginRight: "6px" }}>🌍</span>
              )}
              {languages[lang].label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      {/* Theme toggle + Notifications + User Actions on the right */}
      <div className="d-flex align-items-center smartfarm-header-right-group">
        <ThemeToggle />
        <span className="smartfarm-header-separator" aria-hidden="true" />
        <Notifications />
        <UserActions />
      </div>
    </Nav>
  );
};

export default SidebarNav;
